<div *ngIf="selectedSubsection" class="dashboard-profile" fxFill fxLayout="column" fxLayoutGap="10px">
  <form
    class="dashboard-profile__form"
    [formGroup]="profileForm"
    dashboardConnectForm
    [connectForm]="selectedSubsection"
    fxLayout="column"
    fxLayoutGap="30px"
  >
    <div *ngIf="isEditorInitialized">
      <mat-tab-group
        mat-align-tabs="end"
        animationDuration="0ms"
        #languageTabsEditor
        (selectedTabChange)="selectTemplateLanguage($event)"
        [disablePagination]="true"
        [selectedIndex]="selectedLanguage?.tabIndex"
      >
        <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
          <ng-template matTabContent>
            <div formArrayName="profileTranslations" *ngFor="let item of profileTranslations?.controls; let i = index">
              <div
                class="dashboard-profile__form-text-editor"
                [formGroupName]="i"
                *ngIf="
                  item.get('language').value === selectedLanguage?.code &&
                  item.get('identifier').value === PROFILE_DESCRIPTION_IDENTIFIER
                "
                fxFill
              >
                <label class="dashboard-profile__form-text-editor-label">Description</label>
                <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
                <mat-error
                  class="dashboard-profile__form-text-editor-error"
                  *ngIf="item.invalid && item.get('translation').hasError('maxlength')"
                >
                  Description should have
                  <strong>at most {{ item.get('translation').errors?.maxlength.requiredLength }}</strong>
                  characters
                </mat-error>
              </div>
            </div>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
    <mat-checkbox formControlName="hasDetails">Details Page</mat-checkbox>
    <dashboard-details-page
      formControlName="detailsPage"
      *ngIf="profileForm?.value?.hasDetails"
      [hasDetails]="profileForm?.value?.hasDetails"
    ></dashboard-details-page>
    <div class="dashboard-profile__form-button" fxLayout="column" fxLayoutAlign="space-around end">
      <button mat-raised-button color="accent" (click)="saveProfile()">
        {{ 'Save Profile' | uppercase }}
      </button>
    </div>
  </form>
</div>
